import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, ViewChild } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatSidenav, MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { KeycloakService } from 'keycloak-angular';
import { environment } from '../../../../../my-app/src/environments/environment';
import { filter } from 'rxjs';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MacroListComponent, Macro } from '../../global-components/macro-list/macro-list.component';
import { ConfigService } from '../../shared-services/config.service';
import { GlobalFilterService } from '../../shared-services/global-filter-service';

@Component({
  selector: 'app-side-navbar',
  imports: [
    CommonModule,
    MatIconModule,
    MatSidenavModule,
    MatToolbarModule,
    MatListModule,
    MatTooltipModule,
    RouterModule,
    MatDialogModule,
  ],
  templateUrl: './side-navbar.component.html',
  styleUrl: './side-navbar.component.scss',
})
export class SideNavbarComponent {
  isExpanded = true;
  showSubmenu: boolean = false;
  isShowing = false;
  showSubSubMenu: boolean = false;
  isCollapsed = true;
  windowWidth = window.innerWidth;
  username!: string;
  logo = environment.COMPANY_LOGO_SRC;
  companyText = environment.COMPANY_LOGO_TEXT;

  menuItems: any[] = [];
   isChatRoute: boolean = false;

  constructor(
    private http: HttpClient,
    private keycloakService: KeycloakService,
    private router: Router,
    private dialog: MatDialog,
    private configService: ConfigService,
    private globalFilterService: GlobalFilterService
  ) {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: any) => {
        this.isChatRoute = event.urlAfterRedirects.includes('/chat');
      });
  }


  async ngOnInit(): Promise<void> {
    const isLoggedIn = await this.keycloakService.isLoggedIn();
    if (isLoggedIn) {
      const userDetails = await this.keycloakService.loadUserProfile();
      this.username =
        `${userDetails?.firstName} ${userDetails?.lastName}`.trim() || 'user';
    }
    this.loadSidenavConfig();
  }
  async logout(): Promise<void> {
    await this.keycloakService.logout(window.location.origin);
    localStorage.clear();
  }

  loadSidenavConfig() {
    this.http
      .get<any[]>('assets/side-navbar-config/sidenav.config.json')
      .subscribe((data) => {
        this.menuItems = data;
      });
  }

  handleMenuItemClick(item: any, event: MouseEvent) {
    if (item.actionId) {
      let filters = this.globalFilterService.getCurrentFilters();
      // If a custom payload is defined on the item, don't merge with global filters
      // to prevent including unwanted properties from other widgets.
      if (item.customPayload) {
        filters = {};
      }
      
      const apiData: any = { 
        skipDefaultPayload: item.skipDefaultPayload || false 
      };
      if (item.customPayload) {
        apiData.customPayload = item.customPayload;
      }
      if (item.headers) {
        apiData.headers = item.headers;
      }

      if (item.openComponent && item.componentType === 'MacroListComponent') {
        const rect = (event.currentTarget as HTMLElement).getBoundingClientRect();
        if (item.apiUrl) {
          this.configService.getApi(item.apiUrl, filters, apiData, item.method || 'post').subscribe((response: any) => {
            const macros: Macro[] = response.list.map((macroName: string) => ({
              name: macroName,
              action: macroName // Assuming action is the same as name for now
            }));
            this.dialog.open(MacroListComponent, {
              width: '100px',
              data: { macros: macros },
              position: {
                top: `${rect.top}px`,
                left: `${rect.right + 10}px`
              },
              hasBackdrop: false
            });
          });
        }
      } else if (item.apiUrl) {
        this.configService.getApi(item.apiUrl, filters, apiData, item.method || 'post').subscribe(data => {
          console.log('Macro data:', data);
          alert('Macros loaded, check console for data.');
        });
      }
    } else if (item.path) {
      this.router.navigate([item.path]);
    }
  }

  toggleSidebar() {
    this.isCollapsed = !this.isCollapsed;
  }

  mouseenter() {
    if (!this.isExpanded) {
      this.isShowing = true;
    }
  }
  mouseleave() {
    if (!this.isExpanded) {
      this.isShowing = false;
    }
  }
  goToHelp() {
    const helpUrl = environment.HELP_URL || 'https://default.help.com';
    window.open(helpUrl, '_blank');
  }

  goToFeedback() {
    const feedbackUrl = environment.FEEDBACK_URL;
    if (feedbackUrl) window.open(feedbackUrl, '_blank');
  }

  showNotifications() {
    alert('Notifications clicked!');
  }
}
